module.exports = __webpack_public_path__ + "media/images/lb/684-1cb6b78e9c9d5c182585453266a7d433.svg";